<template lang='pug'>
  div
    app-header(class="u-relative c-header--search u-border-bottom")

    //- hr(class="u-mb4 u-mt0")
    app-publicities(
      class='u-show@tablet'
      v-if='firstGroup.length > 0'
      :publicities='firstGroup')

    section(class="o-wrapper u-flex u-pt4" id='posts-container')
      div(class="u-flex-1 u-pb5")
        div(class="c-search-input__wrapper")
          input(class='c-search-input' type='text', placeholder='Buscar noticias', @keyup='searchPosts($event)', @keyup.enter='searchNews($event)', :value='$route.query.q')
          i(class="u-icon c-search-input__icon") search

        p
          span(class="u-fw-s-bold u-color-text" v-if='posts.length > 0') Página {{currentPage}} con {{ posts.length }} de {{totalPosts}}  noticias&nbsp;
          span(v-if='this.$route.query.q' class='u-fw-s-bold u-color-text') para&nbsp;
          span(v-if='this.$route.query.q' class='u-fw-bold u-color-primary') {{ this.$route.query.q }}

        hr.u-mb4

        section()
          app-post(v-for="(post, index) in posts", :post="post", :key='post.slug')

          //- article(class='c-search-news' v-for='post in posts')
            figure(class='c-search-news__image')
              img(:src='post.imageUrl')
            div(class='c-search-news__content')
              span(class='u-uppercase u-fw-x-bold u-letter-2 u-color-primary') {{ post.category }}
              router-link(:to="{ name: 'Post', params: { slug: post.slug }}" class='c-search-news__title') {{ post.title }}
              span(class='u-color-text u-block u-mb3') {{ post.happened }}
              router-link(:to="{ name: 'Post', params: { slug: post.slug }}" class='u-color-text c-btn-go u-px2 u-py2')
                i(class='u-icon u-fz-h4') arrow_extend_right

        div(v-if='posts.length === 0')
          p(class='u-fz-h3' class='u-mb5') No se encontró ninguna noticia

        nav(class='u-flex u-justify-between u-items-center' v-if='posts.length > 0 && totalPages != 1')
          button(class="c-btn--paginate u-p2 u-fz-h4", :disabled='currentPage === 1' @click="prevPage" v-scroll-to="'#posts-container'")
            i(class='u-icon') arrow_left
          //- ul(class='u-flex u-mt0 u-mb0 u-px2 u-flex-wrap' v-if='totalPages > 0')
            li(class='u-px1' v-for='number in totalPages')
              button(@click="changePage(number)" v-scroll-to="'#posts-container'" class="u-fw-s-bold u-px1", :class="{'u-color-primary' : currentPage === number}")  {{number}}
          button(class="c-btn--paginate u-p2 u-fz-h4", :disabled='totalPages === currentPage' @click="nextPage" v-scroll-to="'#posts-container'")
            i(class='u-icon') arrow_right

      aside(ref='aside_container' class='u-ml4 u-show@laptop', style='width:280px')
        div(ref='aside' style='width:280px' class='u-pt4')
          p(class='c-btn u-bg-primary u-mt0 u-white u-uppercase u-mb0 u-fw-s-bold') categorías
          hr(class='u-mt0')
          ul(class='c-search-list')
            li(class='u-px2')
              router-link(:to="{name: 'Search'}" class='c-search-list__item')
                i(class='u-icon u-mr2') circle
                span(class='u-left-align') Todas las categorías

            li(v-for='category in categories' class='u-px2')
              router-link(:to="{name: 'SearchCategory', params: { slug: category.slug }}" class='c-search-list__item')
                i(class='u-icon u-mr2') circle
                span(class='u-capitalize') {{ category.name }}
          p(class='c-btn u-bg-primary u-mt0 u-white u-uppercase u-mb0 u-fw-s-bold') fechas
          hr(class='u-mt0')
          ul(class='c-search-list')
            li(class='u-px2')
              button(class='c-search-list__item u-pl0 u-pr0', :class="selectedDate === 'all' ? 'is-active' : ''")
                i(class='u-icon u-mr2') circle
                span(@click="selectDate('all')") Todas las fechas
            li(class='u-px2')
              button(class='c-search-list__item u-pl0 u-pr0', :class="selectedDate === 'day' ? 'is-active' : ''")
                i(class='u-icon u-mr2') circle
                span(@click="selectDate('day')") Últimas 24 horas
            li(class='u-px2')
              button(class='c-search-list__item u-pl0 u-pr0', :class="selectedDate === 'week' ? 'is-active' : ''")
                i(class='u-icon u-mr2') circle
                span(@click="selectDate('week')") Última semana
            li(class='u-px2')
              button(class='c-search-list__item u-pl0 u-pr0', :class="selectedDate === 'month' ? 'is-active' : ''")
                i(class='u-icon u-mr2') circle
                span(@click="selectDate('month')") Último mes
            li(class='u-px2')
              button(class='c-search-list__item u-pl0 u-pr0', :class="selectedDate === 'year' ? 'is-active' : ''")
                i(class='u-icon u-mr2') circle
                span(@click="selectDate('year')") Último año
    app-footer
    loading(v-if='isLoading')
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import debounce from 'lodash.debounce'
  import axios from 'axios'

  export default {
    name: 'SearchScreen',
    computed: {
      ...mapGetters({
        categories: 'categories',
        selectedCategory: 'selectedCategory'
      })
    },

    data () {
      return {
        posts: [],
        firstGroup: [],
        currentPage: 1,
        totalPages: 1,
        isLoading: true,
        totalPosts: 0,
        // selectedCategory: 0,
        selectedDate: 'all'
      }
    },

    methods: {
      ...mapActions({
        selectCategory: 'selectCategory'
      }),

      selectDate (value) {
        this.selectedDate = value
        this.currentPage = 1
        this.totalPages = 1
        this.getPosts()
      },

      updateCategory (id) {
        this.selectCategory(id)
        this.currentPage = 1
        this.totalPages = 1
        this.getPosts()
      },

      prevPage () {
        if (this.currentPage > 1) {
          this.currentPage -= 1
          this.getPosts()
        }
      },

      nextPage () {
        if (this.currentPage < this.totalPages) {
          this.currentPage += 1
          this.getPosts()
        }
      },

      changePage (page) {
        this.currentPage = page
        this.getPosts()
      },

      getPosts () {
        axios.get(`${window.API_URL}/search`, {
          params: {
            page: this.currentPage,
            date: this.selectedDate,
            category_slug: this.$route.params.slug,
            q: this.$route.query.q
          }
        })
          .then(({data}) => {
            this.totalPages = data.last_page
            this.posts = data.data
            window.scroll(0, 100)
            this.isLoading = false
            this.totalPosts = data.total
            // setTimeout(() => {
            //   this.mountAside()
            // }, 500)
            // if (this.currentPage < this.totalPages) {
            //   window.addEventListener('scroll', this.handleScroll)
            // } else {
            //   window.removeEventListener('scroll', this.handleScroll)
            // }
          })
      },

      mountAside () {
        let $aside = window.$(this.$refs.aside)
        let $asideContainer = window.$(this.$refs.aside_container)

        $aside.pushpin({
          top: $aside.offset().top,
          bottom: $aside.offset().top + $asideContainer.outerHeight() - $aside.outerHeight()
        })
      },

      searchNews (value) {
        this.showSearchFlag = false
        if (value.target.value.trim()) {
          this.$router.push({name: 'Search', query: { q: value.target.value }})
        } else {
          this.$router.push({name: 'Search'})
        }
      },

      searchPosts: debounce(function (value) {
        this.searchNews(value)
      }, 500),

      getPublicities () {
        axios.get(`${window.API_URL}/publicities`)
          .then(({data}) => {
            this.firstGroup = data.firstGroup
          })
      }
    },

    created () {
      this.getPosts()
      this.getPublicities()
    },

    mounted () {
      // setTimeout(() => {
      //   this.mountAside()
      // }, 500)
    },

    beforeDestroy () {
      this.selectCategory(0)
      // let $aside = window.$(this.$refs.aside)
      // $aside.pushpin('remove')
    },

    watch: {
      '$route' (val, oldVal) {
        this.isLoading = true
        this.selectedDate = 'all'
        this.currentPage = 1
        // this.selectCategory(0)
        this.getPosts()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Search/components/SearchScreen.vue